(function () {
  'use strict';

  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      'cards': {
        'allCardsOverview': 'Pregled svih kartica',
        'ownerName': 'Ime i prezime',
        'expiryDate': 'Datum isteka',
        'status': 'Status',
        'cardStatus': 'Status kartice',
        'dearCustomer': 'Poštovani korisniče,',
        'changeLimitInProgress': 'Poštovani korisniče, <br><br> Vaš zahtjev za promjenu je u tijeku',
        'activationInProgress': 'Poštovani korisniče, <br><br> Vaš zahtjev za aktivaciju kartice je u tijeku',
        'blockInProgress': 'Poštovani korisniče, <br><br> Vaš zahtjev za blokadu kartice je u tijeku',
        'unblockInProgress': 'Poštovani korisniče, <br><br> Vaš zahtjev za deblokadu kartice je u tijeku',
        'statuses': {
            'Active': 'Aktivacija u tijeku',
            'Blocked': 'Blokirana',
            'SentBlockRequest': 'Blokada u tijeku',
            'SentUnblockRequest': 'Deblokada u tijeku',
            'SentActivationRequest': 'Aktivacija u tijeku',
        },
        "nodata": "Nema podataka za prikaz",
        'activation': 'Aktivacija kartice',
        'block': 'Blokada kartice',
        'settings': 'Postavke kartice',
        'settingsSign': 'Postavke kartice - autorizacija',
        'activationSign': 'Aktivacija kartice - autorizacija',

        'temporaryBlock': 'Privremena blokada kartice', 
        'cardBlocked': 'Kartica je blokirana', 
        'cardActive': 'Kartica nije blokirana', 
        
        'onlineShopping': 'Internet kupnja', 
        'enabled': 'Omogućena', 
        'disabled': 'Onemogućena', 

        'dailyLimits': 'Promjene dnevnih limita',
        'POS': 'Kupnja na prodajnim mjestima',
        'ATM': 'Podizanje gotovine na bankomatima',
        'Other': 'Podizanje gotovine na ostalim isplatnim mjestima',
        'change': 'Promijeni',
        'save': 'Potvrdi',
        'cancel': 'Natrag',
        'confirm': 'Potvrdi',
        'acceptChanges': 'Prihvati promjene',
        'dailyLimit': 'Dnevni limit – iznos: ',
        'trnNo': 'Dnevni limit – broj transakcija: ',
        'dailyLimitInfo': 'Povećanjem dnevnih limita za korištenje kartice, povećan je i rizik (iznos potencijalnog gubitka) u slučaju neovlaštenog korištenja kartice zbog krađe kartice ili podataka s kartice.'


      }
    };

    $translateProvider
      .translations('hr', data);

  }
}());
